import React from 'react'

export default function popupComponents(props) {    
  return (
      <div className={props.propClass} >
        <span className="blk-ovrly" onClick={props.hidePopup}></span>
        <div className="abt-pop">
        <button type="button" className="abt-cls-btn" onClick={props.hidePopup}></button>
        <div className="abt-txt">
            <p>{props.pertext}</p>
        </div>
        </div>
    </div>
  )
}
